import * as actionTypes from './actionTypes';

export const setSearchPrice = (payload: any) => ({
    type: actionTypes.SET_SEARCHPRICE,
    payload,
});

export const setSearchPriceSuccess = (payload: any) => ({
    type: actionTypes.SET_SEARCHPRICE_SUCCESS,
    payload,
});

export const setSearchInfoCalendar = (payload: any) => ({
    type: actionTypes.SET_SEARCHINFOCALENDAR,
    payload,
})

export const setSearchInfoCalendarSuccess = (payload: any) => ({
    type: actionTypes.SET_SEARCHINFOCALENDAR_SUCCESS,
    payload,
})
export const setSearchInfoCalendarBar = (payload: any) => ({
    type: actionTypes.SET_SEARCHINFOCALENDAR_BAR,
    payload,
})

export const setSearchInfoCalendarBarSuccess = (payload: any) => ({
    type: actionTypes.SET_SEARCHINFOCALENDAR_BAR_SUCCESS,
    payload,
})

export const setUrlparams = (payload: any) => ({
    type: actionTypes.SET_URLPARAMS,
    payload,
});

export const setFilterData = (payload: any) => ({
    type: actionTypes.SET_FILTERDATA,
    payload,
});

export const setShowData = (payload: any) => ({
    type: actionTypes.SET_SHOWDATA,
    payload,
});

export const setSortType = (payload: any) => ({
    type: actionTypes.SET_SORTTYPE,
    payload,
});

export const setMiniRuleInfo = (payload: any) => ({
    type: actionTypes.SET_MINIRULEINFO,
    payload,
});

export const setMiniRuleInfoSuccess = (payload: any) => ({
    type: actionTypes.SET_MINIRULEINFO_SUCCESS,
    payload,
});

export const setFlightFixedRule = (payload: any) => ({
    type: actionTypes.SET_FLIGHTFIXEDRULE,
    payload,
});

export const setFlightFixedRuleSuccess = (payload: any) => ({
    type: actionTypes.SET_FLIGHTFIXEDRULE_SUCCESS,
    payload,
});

export const setNoticeInfo = (payload: any) => ({
    type: actionTypes.SET_NOTICEINFO,
    payload,
})

export const setSaleInfo = (payload: any) => ({
    type: actionTypes.SET_SALEINFO,
    payload,
})

export const setFareRuleInfo = (payload: any) => ({
    type: actionTypes.SET_FARERULEINFO,
    payload,
});

export const setFareRuleInfoSuccess = (payload: any) => ({
    type: actionTypes.SET_FARERULEINFO_SUCCESS,
    payload,
});